import axios from 'axios';

export default {
  async list() {
    const { data } = await axios.get('https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/hashpower/ftx/list');
    return data.map(v => ({
      ...v,
      // name: /\d+ Q\d/.exec(v.name)[0],
      coin: 'BTC', payoffType: ['BTC']
    }));
  },
  getFullData(item, coin, blockchainInfo) {
    const priceUsd = item.contract_cost_btc * blockchainInfo.BTC.price;
    const priceBtc = item.contract_cost_btc;

    return { ...item, priceBtc, priceUsd };
  }
}